var Theme = Theme || {};

Theme.ConferenceVolumeSelector = (function ($) {

    var $widgetConferencesBrowseByYear;

    return {
        init: _init
    };

    function _init() {
        $widgetConferencesBrowseByYear = $('.widget-ConferencesBrowseByYear');

        navigateOnConferenceVolumeChange();
        navigateOnYearSelectChange();
        navigateOnDecadeSelectChange();
    }

    function navigateOnConferenceVolumeChange() {
        $widgetConferencesBrowseByYear.on('change', '.js-volume-browse-select, .js-volume-browse-conference-select', function (e) {
            var redirectUrl = $(e.target).val();
            _navigateToRedirectUrl(redirectUrl);
        });
    }

    function navigateOnYearSelectChange() {
        $widgetConferencesBrowseByYear.on('change', '.js-volume-browse-year-select', function (e) {
            var year = $(e.target).val();
            _getLatestConferenceVolumeByYear(year, false);
        });
    }

    function navigateOnDecadeSelectChange() {
        $widgetConferencesBrowseByYear.on('change', '.js-volume-browse-decade-select', function (e) {
            var year = $(e.target).val();
            _getLatestConferenceVolumeByYear(year, true);
        });
    }

    function _getLatestConferenceVolumeByYear(year, isDecade) {
        var ajaxUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/ConferenceVolume/ConferenceVolumeLatestByYear';

        SCM.Ajax.get(ajaxUrl, { year: year, isDecade: isDecade })
            .expectActionResultModel()
            .expectRedirectUrl()
            .then(function (redirectUrl) {
                _navigateToRedirectUrl(redirectUrl);
            })
            .catch(console.error);
    }

    function _navigateToRedirectUrl(redirectUrl) {
        window.location = redirectUrl;
    }

})(jQuery);
